/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefProjectData } from '../../models/api-def-project-data';
import { ApiDefSpecCheckResult } from '../../models/api-def-spec-check-result';

export interface OrganizationsCheckSpecAndCreateVersion$Params {

/**
 * The ID of the organization to upload the spec to
 */
  organizationId: string;

/**
 * The ID of the project to upload the spec to
 */
  projectId: string;
      body: {

/**
 * The ID associated with the upload intent
 */
'uploadIntentId': string;

/**
 * The name of the spec version
 */
'versionName': string;

/**
 * The ID of the organization. Provide in case you use apiKey auth.
 */
'organizationId'?: string;
}
}

export function organizationsCheckSpecAndCreateVersion(http: HttpClient, rootUrl: string, params: OrganizationsCheckSpecAndCreateVersion$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * The results of the spec validation
 */
'results'?: Array<ApiDefSpecCheckResult>;
'project'?: ApiDefProjectData;
}>> {
  const rb = new RequestBuilder(rootUrl, organizationsCheckSpecAndCreateVersion.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('projectId', params.projectId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * The results of the spec validation
       */
      'results'?: Array<ApiDefSpecCheckResult>;
      'project'?: ApiDefProjectData;
      }>;
    })
  );
}

organizationsCheckSpecAndCreateVersion.PATH = '/organizations/{organizationId}/projects/{projectId}/specs';
